import styled from 'styled-components';

import { border1, green, lightGray } from 'utils/style/colors';

export const Wrapper = styled('div')`
  transition: 0.3s all ease;
  border-radius: 10px;
  border: 1px solid var(--gray);
  background-color: var(--exact-white);
  margin: 1rem 0;
  &:hover {
    background-color: #fdfdfd;
    border-color: #d2d2d2;
  }
`;

export const SelectTitle = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  & > i {
    color: ${green};
  }
`;

export const SearchContainer = styled('div')`
  margin-bottom: 1rem;
  margin-right: 1rem;
  margin-left: 1rem;
`;

export const SearchInput = styled('input')`
  border: ${border1};
  border-radius: 10px !important;
  box-sizing: border-box !important;
  padding: 0 1rem !important;
  margin: 0 !important;
  &:focus {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1) !important;
    border-color: #dcdcdc !important;
  }
`;

export const ItemList = styled('ul')`
  overflow-y: auto;
  overflow-y: overlay;
  max-height: 20em;
  margin-bottom: 0;
`;

export const Item = styled('li')`
  cursor: pointer;
  padding: 0.7rem 1rem;
  border-top: 1px solid #ececec;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  &:hover {
    background-color: ${lightGray};
  }
`;

export const EmptyItem = styled('li')`
  color: silver;
  text-align: center;
  padding: 0.7rem 1rem;
`;
